var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy-26",
    transform: "translate(-419.000000, -356.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(419.000000, 356.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,0 C5.59644063,0 0,5.59644063 0,12.5 C0,19.4035594 5.59644063,25 12.5,25 C19.4035594,25 25,19.4035594 25,12.5 C25,5.59644063 19.4035594,0 12.5,0 Z M12.5,0.961538462 C18.8725163,0.961538462 24.0384615,6.12748366 24.0384615,12.5 C24.0384615,18.8725163 18.8725163,24.0384615 12.5,24.0384615 C6.12748366,24.0384615 0.961538462,18.8725163 0.961538462,12.5 C0.961538462,6.12748366 6.12748366,0.961538462 12.5,0.961538462 Z",
    id: "Oval",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3715833,7.8048412 C19.5593353,7.61708913 19.8637416,7.61708913 20.0514936,7.8048412 C20.2183844,7.97173192 20.2369278,8.23079384 20.1071239,8.41816706 L20.0514936,8.48475156 L11.3410864,17.1951588 C11.1741957,17.3620495 10.9151338,17.3805929 10.7277605,17.250789 L10.661176,17.1951588 L5.91004482,12.4440276 C5.72229275,12.2562755 5.72229275,11.9518693 5.91004482,11.7641172 C6.07693554,11.5972265 6.33599746,11.5786831 6.52337068,11.708487 L6.58995518,11.7641172 L11.0009615,16.175 L19.3715833,7.8048412 Z",
    id: "Path-5",
    fill: "#E10600"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.a7186ea473644d0dc83bdf6dcec8e768.svg";
export { ForwardRef as ReactComponent };